import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import KindergartenNurseryList from "src/components/panel/kindergarten_nursery/KindergartenNurseryList";

const KindergartenNurseryListView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("kindergarten_nursery_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("kindergarten_nursery_title")}
          subtitle={t("kindergarten_nursery_subtitle")}
        />
        <KindergartenNurseryList />
      </Sidebar>
    </>
  );
};

export default KindergartenNurseryListView;
